module.exports = "input:focus.ng-invalid:not(form) {\n  border: red 4px solid;\n}\n\ninput:focus.ng-valid:not(form) {\n  border: green 4px solid;\n}\n\ninput.ng-valid:not(form).ng-dirty:not(form) {\n  border: green 4px solid;\n}\n\n/* input.form-control {\n  padding-top: 0em;\n  padding-bottom: 0em;\n}\n */\n\ndiv.form-group {\n  margin-bottom: 1.0em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/remittance-entry/adjustment-code/adjustment-code.component.css
// module id = ./src/app/components/remittance-entry/adjustment-code/adjustment-code.component.css
// module chunks = main